{
  "tabs": {
    "chat": "Chat",
    "reminders": "Mga Paalala",
    "calendar": "Kalendaryo",
    "settings": "Mga Setting"
  },
  "common": {
    "cancel": "Kanselahin",
    "save": "I-save",
    "confirm": "Kumpirmahin",
    "delete": "Tanggalin",
    "back": "Bumalik",
    "close": "Isara",
    "edit": "I-edit",
    "search": "Hanapin",
    "all": "Lahat",
    "loading": "Naglo-load...",
    "error": "May nagkamaling nangyari",
    "notFound": "Hindi nakita",
    "tryAgain": "Pakisubukang muli",
    "retry": "Subukang muli",
    "undo": "Bawiin",
    "pullToRefresh": "Hilahin para mag-refresh",
    "justNow": "kakatapos lang"
  },
  "auth": {
    "welcome": "Maligayang pagdating sa FishMemory",
    "tagline": "Ang iyong WhatsApp assistant sa paalala, ngayon nasa bulsa mo na.",
    "subtitle": "Ang iyong WhatsApp assistant sa paalala, ngayon nasa bulsa mo na.",
    "phoneLabel": "Iyong WhatsApp na numero",
    "phoneHint": "Magpapadala kami ng verification code sa WhatsApp",
    "invalidPhone": "Pakilagay ang tamang numero ng telepono",
    "continue": "Magpatuloy",
    "enterPhone": "Ilagay ang iyong WhatsApp na numero",
    "phonePlaceholder": "Numero ng telepono",
    "sendCode": "Ipadala ang Code",
    "verifyTitle": "I-verify ang iyong numero",
    "otpSentTo": "Isang 6-digit na code ang ipinadala sa {{phone}} via WhatsApp",
    "enterFullCode": "Pakilagay ang lahat ng 6 na digit",
    "invalidOtp": "Maling code. Pakisubukang muli.",
    "otpFailed": "Nabigong magpadala ng code. Subukang muli.",
    "otpResent": "Muling ipinadala ang code",
    "resendIn": "Muling ipadala sa loob ng {{seconds}}s",
    "resendCode": "Muling ipadala ang code",
    "enterOtp": "Ilagay ang code na ipinadala sa iyong WhatsApp",
    "verify": "I-verify",
    "resend": "Muling ipadala ang code",
    "wrongNumber": "Maling numero?",
    "backToPhone": "Bumalik sa numero",
    "editPhone": "I-edit ang numero",
    "error": "Error",
    "setupTitle": "Ayusin natin",
    "setupSubtitle": "Maaari mong baguhin ito sa Mga Setting anumang oras",
    "namePlaceholder": "Iyong pangalan",
    "letsGo": "Tapusin ang setup",
    "skipForNow": "Laktawan muna"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Mag-type ng mensahe...",
    "inputPlaceholder": "Mag-type ng mensahe...",
    "typing": "Nagtatype si FishMemory...",
    "online": "Online",
    "connecting": "Kokonekta...",
    "reconnecting": "Muling kumokonekta...",
    "offline": "Offline",
    "empty": "Magsimula ng usapan",
    "emptyHint": "Gumawa ng mga paalala, tingnan ang iskedyul, o humingi ng tulong.",
    "emptyAction": "Magpadala ng sample na paalala",
    "actions": "Mga aksyon sa chat",
    "keep": "Panatilihin ang mga mensahe",
    "clearTitle": "Linisin ang chat",
    "clearConfirm": "Tanggalin lahat ng mensahe sa device na ito? Hindi na ito mababawi.",
    "clear": "Linisin ang chat",
    "optionSelected": "Napili: {{label}}",
    "sendingSelection": "Nagpapadala...",
    "connectionLost": "Muling kumokonekta..."
  },
  "reminders": {
    "title": "Aking Mga Paalala",
    "active": "Aktibo",
    "today": "Ngayon",
    "thisWeek": "Ngayong Linggo",
    "history": "Kasaysayan",
    "items": "mga item",
    "emptyTitle": "Walang paalala",
    "emptySubtitle": "Gumawa mula sa chat at lalabas dito.",
    "emptyAction": "Buksan ang chat",
    "filterActive": "Aktibo",
    "filterToday": "Ngayon",
    "filterWeek": "Ngayong Linggo",
    "filterHistory": "Kasaysayan",
    "emptyState": "Walang paalala. Magsimula ng chat!",
    "swipeDone": "Tapos na",
    "swipeSnooze": "Ipagpaliban",
    "swipeDelete": "Tanggalin",
    "search": "Hanapin ang mga paalala...",
    "upcoming": "Malapit na",
    "completed": "Natapos",
    "overdue": "Nalampasan na",
    "tomorrow": "Bukas",
    "synced": "Na-sync {{value}}",
    "swipeHint": "I-swipe ang paalala para sa higit pang aksyon",
    "noResults": "Walang paalala na tumutugma sa iyong paghahanap",
    "noResultsHint": "Subukang ibang keyword o linisin ang paghahanap",
    "deleteAllFailed": "Nabigong tanggalin lahat ng paalala"
  },
  "calendar": {
    "title": "Kalendaryo",
    "today": "Ngayon",
    "tomorrow": "Bukas",
    "completed": "tapos na",
    "noEvents": "Walang naka-iskedyul",
    "noEventsSubtitle": "Pumili ng petsa para makita ang mga paalala at kaganapan sa kalendaryo.",
    "googleEvent": "Google Calendar",
    "legendActive": "Aktibo",
    "legendRecurring": "Umiikot",
    "legendDone": "Tapos na",
    "legendGoogle": "Google",
    "previousMonth": "Nakaraang buwan",
    "nextMonth": "Susunod na buwan",
    "previousYear": "Nakaraang taon",
    "nextYear": "Susunod na taon",
    "goToToday": "Pumunta sa ngayon",
    "all": "Lahat",
    "active": "Aktibo",
    "done": "Tapos na",
    "paused": "Pahinto"
  },
  "settings": {
    "title": "Mga Setting",
    "profile": "Profile",
    "name": "Pangalan sa Display",
    "enterName": "Ilagay ang iyong pangalan",
    "language": "Wika",
    "uiLanguage": "Wika ng app",
    "uiLanguageHelp": "Binabago ang UI ng app, mga label ng kalendaryo, at direksyon ng layout sa device na ito lamang.",
    "serverLanguage": "Wika ng chat",
    "serverLanguageHelp": "Binabago ang wikang ginagamit ng mga sagot ng server at mga mensahe ng paalala para sa iyong account.",
    "timezone": "Timezone",
    "currentTimezone": "Kasalukuyang timezone",
    "timezoneHelp": "Lahat ng oras ng paalala ay ipinapakita gamit ang timezone na ito.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "I-save ang timezone",
    "timezoneSaved": "Na-update ang timezone",
    "detect": "Tuklasin",
    "detectFailed": "Hindi matukoy ang timezone",
    "autoDetect": "Awtomatikong tuklasin mula sa GPS",
    "notifications": "Mga Notipikasyon",
    "notificationsHelp": "Kinokontrol ng follow-up reminders ang paulit-ulit na alerto pagkatapos maipadala ang paalala. Ang mga pahintulot sa notipikasyon sa device ay pinamamahalaan pa rin sa iyong mga setting ng telepono.",
    "pushEnabled": "Push Notifications",
    "autoDoneOnFire": "Awtomatikong markahan bilang tapos kapag na-trigger",
    "autoDoneOnFireDesc": "Kapag naka-off, mananatiling aktibo ang mga paalala hanggang markahan mo bilang tapos.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Nakakonekta",
    "googleDisconnected": "Hindi nakakonekta",
    "googleConnectedHelp": "Maaaring awtomatikong ma-sync ang mga bagong paalala sa iyong kalendaryo.",
    "googleDisconnectedHelp": "Ikonekta ang Google Calendar para mapanatiling tugma ang mga paalala at kaganapan.",
    "googleConnectFailed": "Nabigong ikonekta ang Google Calendar",
    "connected": "Nakakonekta",
    "disconnected": "Hindi nakakonekta",
    "connect": "Ikonekta",
    "disconnect": "Idiskonekta",
    "autoSync": "Awtomatikong i-sync ang mga bagong paalala",
    "autosync": "Awtomatikong i-sync ang mga bagong paalala",
    "subscription": "Subscription",
    "trialUsed": "Pagsubok: {{used}}/{{total}} nagamit",
    "trialStatus": "May available na pagsubok",
    "activeStatus": "Aktibong subscription",
    "expiredStatus": "Nag-expire ang subscription",
    "unsubscribedStatus": "Hindi naka-subscribe",
    "about": "Tungkol sa",
    "version": "Bersyon",
    "logout": "Mag-logout",
    "logoutTitle": "Mag-logout",
    "logoutConfirm": "Sigurado ka bang mag-logout?",
    "noName": "Walang nakatakdang pangalan",
    "serverConnection": "Koneksyon sa server",
    "serverUrl": "URL ng server",
    "serverEdit": "I-edit",
    "saveReconnect": "I-save at muling kumonekta",
    "resetDefault": "I-reset sa default",
    "invalidServerUrlTitle": "Hindi wastong URL ng server",
    "invalidServerUrlMessage": "Maglagay ng wastong http o https na URL ng server, halimbawa https://example.com",
    "uiLanguageChangeFailed": "Nabigong baguhin ang wika ng app. Pakisubukang muli.",
    "serverLanguageChangeFailed": "Nabigong baguhin ang wika ng chat. Pakisubukang muli.",
    "timezoneChangeFailed": "Nabigong baguhin ang timezone. Pakisubukang muli.",
    "autoSyncChangeFailed": "Nabigong i-update ang auto-sync. Pakisubukang muli.",
    "nameChangeFailed": "Nabigong i-update ang display name. Pakisubukang muli.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detalye ng paalala",
    "editTime": "I-edit ang Oras",
    "rename": "Palitan ang pangalan",
    "snooze": "Ipagpaliban",
    "snooze15": "Ipagpaliban ng 15 minuto",
    "pause": "Pahintuin",
    "pauseReminder": "Pahintuin ang paalala",
    "resume": "Ipagpatuloy",
    "resumeReminder": "Ipagpatuloy ang paalala",
    "skip": "Laktawan ang Susunod",
    "skipOccurrence": "Laktawan ang pagkakataong ito",
    "syncGoogle": "I-sync sa Google",
    "delete": "Tanggalin",
    "deleteTitle": "Tanggalin ang Paalala",
    "deleteConfirm": "Permanenteng matatanggal ang paalala na ito.",
    "deleteRecurringTitle": "Tanggalin ang Umiikot na Paalala",
    "deleteRecurringMessage": "Gusto mo bang laktawan ang pagkakataong ito o tanggalin ang buong serye?",
    "deleteThisOccurrence": "Laktawan ang pagkakataong ito",
    "deleteEntireSeries": "Tanggalin ang buong serye",
    "done": "Tapos na",
    "markDone": "Markahan bilang tapos",
    "undo": "Ibalik",
    "undoPrompt": "Kailangan mo ba itong gawing aktibo muli? Ibalik na ngayon.",
    "recurring": "Umiikot",
    "nextRun": "Susunod na takbo",
    "oneTime": "Isang beses lang",
    "pending": "Nakahanda",
    "sent": "Naipadala",
    "paused": "Pahinto",
    "active": "Aktibo",
    "snoozed": "Naipagpaliban",
    "localTime": "Ipinapakita sa iyong lokal na oras",
    "recurrence": "Pag-uulit",
    "created": "Nilikha",
    "tags": "Mga tag",
    "fireCount": "Bilang ng pag-trigger",
    "actions": "Mga aksyon",
    "none": "Wala",
    "snoozeFailed": "Nabigong ipagpaliban ang paalala",
    "pauseFailed": "Nabigong pahintuin ang paalala",
    "resumeFailed": "Nabigong ipagpatuloy ang paalala",
    "skipFailed": "Nabigong laktawan ang paalala",
    "doneFailed": "Nabigong markahan ang paalala bilang tapos",
    "undoFailed": "Nabigong ibalik ang status ng paalala",
    "deleteFailed": "Nabigong tanggalin ang paalala",
    "rescheduleTitle": "I-reschedule?",
    "rescheduleMsg": "Nalampasan na ang paalala na ito. Gusto mo bang i-reschedule?",
    "reschedule15": "Sa loob ng 15 minuto",
    "reschedule60": "Sa loob ng 1 oras",
    "keepOverdue": "Panatilihin na lang"
  },
  "onboarding": {
    "slide1Title": "Maligayang pagdating sa FishMemory",
    "slide1Sub": "Ang iyong personal na assistant sa paalala — pinapagana ng WhatsApp at ginawa para sa iyong bulsa.",
    "slide2Title": "Mag-chat nang Natural",
    "slide2Sub": "I-type ang mga paalala ayon sa iniisip mo: \"Paalalahanan mo akong tawagan si mama bukas ng 3pm\" — kami na ang bahala sa iba.",
    "slide3Title": "Huwag Palampasin",
    "slide3Sub": "Tumanggap ng napapanahong notipikasyon, ayusin gamit ang mga tag, at manatiling nakaayos sa lahat ng mahalaga.",
    "getStarted": "Magsimula",
    "next": "Susunod",
    "firstReminderTitle": "Gumawa ng iyong unang paalala!",
    "firstReminderHint": "Subukang mag-type ng ganito:",
    "firstReminderExample": "Paalalahanan mo akong uminom ng tubig bukas ng 9 AM",
    "gotIt": "Naintindihan!",
    "notifRationaleTitle": "Manatiling Nasa Oras",
    "notifRationaleBody": "Kailangan ng FishMemory ng notipikasyon para paalalahanan ka sa tamang oras. Makakatanggap ka lang ng alerto para sa mga paalalang ginawa mo.",
    "notifRationaleAllow": "Paganahin ang Notipikasyon",
    "notifRationaleLater": "Siguro Mamaya",
    "swipeHint": "I-swipe pakanan para sa mabilisang aksyon →",
    "calendarDragHint": "Hilahin para palawakin ↕"
  }
}
